import { componentPermissions } from 'config/permissions'
import { componentNames } from 'config/roles'
import { FC } from 'react'
import { RoutePaths } from 'routes/paths'
import { ContentBody } from 'components/pages/components/ContentBody'
import { IAccordionData, DynamicAccordion } from './components/DynamicAccordion'
import { EnergyMixDocumentData } from './Data/EnergyMixDocumentData'

const EnergyMixDocument: FC = () => {
  return (
      <ContentBody title="knowledgeHub.energy">
        {EnergyMixDocumentData.map((d: IAccordionData, key: number) => (
          <DynamicAccordion data={d} index={key} key={key} />
        ))}
      </ContentBody>
  )
}

const exportObj = {
  routeProps: {
    // This gets passed straight to react-router
    path: RoutePaths.knowledgeHubEnergy,
    title: 'knowledgeHub.energy',
    element: <EnergyMixDocument />,
    roles: componentPermissions[componentNames.pageKnowledgeHubEnergy],
    requiresAuthentication: true,
  },
  name: 'Energy',
}
export default exportObj
